import { InjectionToken } from '@angular/core';
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

export const FRIENDLY_CAPTCHA_SDK = new InjectionToken<FriendlyCaptchaSDK>(
  'FRIENDLY_CAPTCHA_SDK'
);
